const OSS = require('ali-oss');
import instance from '@/http/http';

let ossConfigOption = {
    'guoranwisdom': {
        region: "oss-cn-zhangjiakou",
        bucket: "guoranwisdom",
    },
    'guoranopen-zjk': {
        region: "oss-cn-zhangjiakou",
        bucket: "guoranopen-zjk",
    },
    "askbotopen-ls": {
        region: "oss-ap-southeast-1",
        bucket: "askbotopen-ls",
    },
    "askbotwisdom-ls": {
        region: "oss-ap-southeast-1",
        bucket: "askbotwisdom-ls",
    }
};

function generateOssConfig(bucketType) {
    let config;
    if (process.env.VUE_APP_SOURCE === 'lishi') {
        if (bucketType === 'open') {
            config = ossConfigOption['askbotopen-ls']
        } else {
            config = ossConfigOption['askbotwisdom-ls']
        }
    } else if (process.env.VUE_APP_SOURCE === 'askbot' || process.env.VUE_APP_CONFIG_ENV !== 'production') {
        if (bucketType === 'open') {
            config = ossConfigOption['guoranopen-zjk']
        } else {
            config = ossConfigOption['guoranwisdom']
        }
    }
    return config;
}

async function getSTSToken() {
    const { data } = await instance.get('/knowledge-api/oss-sts-token/get');
    const info = data.data || data;
    return {
        accessKeyId: info.accessKeyId,
        accessKeySecret: info.accessKeySecret,
        stsToken: info.stsToken,
    };
}

async function createOssClient(ossConfig) {
    const credentials = await getSTSToken();
    return new OSS({
        ...ossConfig,
        ...credentials,
        authorizationV4: true,
        refreshSTSToken: getSTSToken,
        refreshSTSTokenInterval: 1800000,
    });
}

export { generateOssConfig, createOssClient }